// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2X03t","label":"CategoryService_label__YzqmN","location":"CategoryService_location__3tD54"};